import React, { useState } from "react";
import downArrow from "../../assests/downArrow.svg";
import upArrow from "../../assests/upArrow.svg";

export default function Accordian({ summary, children, buttonColor }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const imageSrc = isOpen ? upArrow : downArrow;

  return (
    <details onToggle={toggleOpen}>
      <summary className="flex justify-between items-center  py-[24px] cursor-pointer">
        <span
          className={` text-regular whitespace-nowrap `}
          style={{ color: isOpen ? buttonColor : "#ffffff" }}
        >
          {summary}
        </span>
        <img src={imageSrc} />
      </summary>
      <div>{children}</div>
    </details>
  );
}
